/**
 * Categories Configuration
 * 
 * Multi-language category definitions for the procurement system.
 * Backend stores only category IDs, frontend handles translations.
 */

export type Language = 'tr' | 'en' | 'de';

export interface CategoryTranslation {
  tr: string;
  en: string;
  de: string;
}

export interface Category {
  id: string;
  name: CategoryTranslation;
  description?: CategoryTranslation;
}

export const CATEGORIES: Category[] = [
  {
    id: "12000000",
    name: {
      tr: "Kimyasal Maddeler ve Gaz Malzemeleri",
      en: "Chemicals including Bio Chemicals and Gas Materials",
      de: "Chemikalien einschließlich Bio-Chemikalien und Gasmaterialien"
    },
    description: {
      tr: "Kimyasal ürünler, biyo kimyasallar ve gaz malzemeleri",
      en: "Chemical products, bio chemicals, and gas materials",
      de: "Chemische Produkte, Bio-Chemikalien und Gasmaterialien"
    }
  },
  {
    id: "27000000",
    name: {
      tr: "Araçlar ve Genel Makine Ekipmanları",
      en: "Tools and General Machinery",
      de: "Werkzeuge und allgemeine Maschinenausrüstung"
    },
    description: {
      tr: "Endüstriyel araçlar ve genel makine ekipmanları",
      en: "Industrial tools and general machinery equipment",
      de: "Industrielle Werkzeuge und allgemeine Maschinenausrüstung"
    }
  },
  {
    id: "39000000",
    name: {
      tr: "Elektrik Sistemleri ve Aydınlatma",
      en: "Electrical Systems and Lighting and Components and Accessories and Supplies",
      de: "Elektrische Systeme und Beleuchtung sowie Komponenten und Zubehör"
    },
    description: {
      tr: "Elektrik sistemleri, aydınlatma, bileşenler, aksesuarlar ve sarf malzemeleri",
      en: "Electrical systems, lighting, components, accessories and supplies",
      de: "Elektrische Systeme, Beleuchtung, Komponenten, Zubehör und Verbrauchsmaterialien"
    }
  },
  {
    id: "41000000",
    name: {
      tr: "Laboratuvar ve Ölçüm Ekipmanları",
      en: "Laboratory and Measuring and Observing and Testing Equipment",
      de: "Labor- und Messausrüstung"
    },
    description: {
      tr: "Laboratuvar ekipmanları, ölçüm, gözlem ve test cihazları",
      en: "Laboratory equipment, measuring, observing and testing instruments",
      de: "Laborausrüstung, Mess-, Beobachtungs- und Testgeräte"
    }
  },
  {
    id: "42000000",
    name: {
      tr: "Tıbbi Ekipmanlar ve Aksesuarlar",
      en: "Medical Equipment and Accessories and Supplies",
      de: "Medizinische Ausrüstung und Zubehör"
    },
    description: {
      tr: "Tıbbi ekipmanlar, aksesuarlar ve sarf malzemeleri",
      en: "Medical equipment, accessories and supplies",
      de: "Medizinische Ausrüstung, Zubehör und Verbrauchsmaterialien"
    }
  },
  {
    id: "44000000",
    name: {
      tr: "Ofis Ekipmanları ve Aksesuarlar",
      en: "Office Equipment and Accessories and Supplies",
      de: "Büroausrüstung und Zubehör"
    },
    description: {
      tr: "Ofis ekipmanları, aksesuarlar ve sarf malzemeleri",
      en: "Office equipment, accessories and supplies",
      de: "Büroausrüstung, Zubehör und Verbrauchsmaterialien"
    }
  },
  {
    id: "50000000",
    name: {
      tr: "Gıda ve İçecek Ürünleri",
      en: "Food Beverage Products",
      de: "Lebensmittel- und Getränkeprodukte"
    },
    description: {
      tr: "Gıda ve içecek ürünleri",
      en: "Food and beverage products",
      de: "Lebensmittel- und Getränkeprodukte"
    }
  },
  {
    id: "51000000",
    name: {
      tr: "İlaçlar ve Eczacılık Ürünleri",
      en: "Drugs and Pharmaceutical Products",
      de: "Arzneimittel und pharmazeutische Produkte"
    },
    description: {
      tr: "İlaçlar ve tıbbi ürünler",
      en: "Pharmaceutical drugs and medicinal products",
      de: "Pharmazeutische Arzneimittel und Medizinprodukte"
    }
  },
  {
    id: "53000000",
    name: {
      tr: "Giyim ve Kişisel Bakım Ürünleri",
      en: "Clothing and Personal Care Products/Equipment",
      de: "Bekleidung und Körperpflegeprodukte/-ausrüstung"
    },
    description: {
      tr: "Giyim ve kişisel bakım ürünleri ve ekipmanları",
      en: "Clothing and personal care products and equipment",
      de: "Bekleidung und Körperpflegeprodukte und -ausrüstung"
    }
  },
  {
    id: "56000000",
    name: {
      tr: "Mobilya ve Ev Eşyaları",
      en: "Furniture and Furnishings",
      de: "Möbel und Einrichtungsgegenstände"
    },
    description: {
      tr: "Mobilya ve ev eşyaları",
      en: "Furniture and furnishing items",
      de: "Möbel und Einrichtungsgegenstände"
    }
  },
  {
    id: "72000000",
    name: {
      tr: "Bina ve Tesis İnşaat Hizmetleri",
      en: "Building and Facility Construction and Maintenance Services",
      de: "Gebäude- und Anlagenbau und Instandhaltungsdienstleistungen"
    },
    description: {
      tr: "Bina ve tesis inşaat ve bakım hizmetleri",
      en: "Building and facility construction and maintenance services",
      de: "Gebäude- und Anlagenbau und Instandhaltungsdienstleistungen"
    }
  },
  {
    id: "81000000",
    name: {
      tr: "Mühendislik ve Teknoloji Hizmetleri",
      en: "Engineering and Research and Technology Based Services",
      de: "Ingenieur- und technologiebasierte Dienstleistungen"
    },
    description: {
      tr: "Mühendislik, araştırma ve teknoloji tabanlı hizmetler",
      en: "Engineering, research and technology-based services",
      de: "Ingenieur-, Forschungs- und technologiebasierte Dienstleistungen"
    }
  },
  {
    id: "99999999",
    name: {
      tr: "Diğer",
      en: "Other",
      de: "Sonstige"
    },
    description: {
      tr: "Yukarıda listelenmeyen diğer kategoriler",
      en: "Other categories not listed above",
      de: "Andere oben nicht aufgeführte Kategorien"
    }
  }
];

/**
 * Get category by ID
 */
export const getCategoryById = (id: string): Category | undefined => {
  return CATEGORIES.find(category => category.id === id);
};

/**
 * Get category name by ID and language
 */
export const getCategoryName = (id: string, language: 'tr' | 'en' | 'de' = 'tr'): string => {
  const category = getCategoryById(id);
  return category ? category.name[language] : id;
};

/**
 * Get category description by ID and language
 */
export const getCategoryDescription = (id: string, language: 'tr' | 'en' | 'de' = 'tr'): string => {
  const category = getCategoryById(id);
  return category ? (category.description?.[language] || '') : '';
};

/**
 * Get all categories formatted for dropdown/select components
 */
export const getCategoriesForSelect = (language: 'tr' | 'en' | 'de' = 'tr'): Array<{
  value: string;
  label: string;
  description?: string;
}> => {
  return CATEGORIES.map(category => ({
    value: category.id,
    label: category.name[language],
    description: category.description?.[language]
  }));
};

/**
 * Get multiple categories by IDs
 */
export const getCategoriesByIds = (ids: string[], language: 'tr' | 'en' | 'de' = 'tr'): Array<{
  id: string;
  name: string;
  description?: string;
}> => {
  return ids.map(id => {
    const category = getCategoryById(id);
    return {
      id,
      name: category ? category.name[language] : id,
      description: category ? category.description?.[language] : ''
    };
  });
};

/**
 * Search categories by name
 */
export const searchCategories = (query: string, language: 'tr' | 'en' | 'de' = 'tr'): Array<{
  value: string;
  label: string;
  description?: string;
}> => {
  const lowercaseQuery = query.toLowerCase();
  return CATEGORIES
    .filter(category => 
      category.name[language].toLowerCase().includes(lowercaseQuery) ||
      category.description?.[language]?.toLowerCase().includes(lowercaseQuery)
    )
    .map(category => ({
      value: category.id,
      label: category.name[language],
      description: category.description?.[language]
    }));
};
